import React from 'react';
import styled from 'styled-components';
import { useBondingCurve } from '@onomy/react-hub';

import { Panel } from 'components/UI';
import { responsive } from 'theme/constants';
import SidebarHeader from './SidebarHeader';
import SidebarBalances from './SidebarBalances';
import SidebarFooter from './SidebarFooter';
// import SidebarConnection from './SidebarConnection';
import NOMBalances from './NOMBalances';

const PanelLayout = styled(Panel)`
  height: 100%;
`;

const SidebarLayout = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;

  @media screen and (max-width: ${responsive.tablet}) {
  }

  @media screen and (max-width: ${responsive.tabletSmall}) {
    /* grid-template-columns: 1fr 250px; */
  }

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    display: flex;
    flex-direction: column;
  }
`;

const DarkWrapper = styled.div`
  margin-top: auto;

  border-radius: 4px;
  background-color: ${props => props.theme.colors.bgDarken};

  @media screen and (max-width: ${responsive.tablet}) {
    background-color: #211d2a;
    border-top: 1px solid ${props => props.theme.colors.bgHighlightBorder};
    border-radius: 0;
  }
`;

export default function Sidebar() {
  const { logout, ethAddress } = useBondingCurve();

  const handleLogout = () => {
    window.localStorage.removeItem('connectorId');
    if (logout) logout();
  };

  return (
    <div id="tour-sidebar">
      <PanelLayout>
        <SidebarLayout>
          <SidebarHeader account={ethAddress} onLogout={handleLogout} />
          <SidebarBalances />
          {/* <SidebarConnection
            active={active}
            error={error}
            chainId={chainId}
            blockNumber={blockNumber}
          /> */}
          <DarkWrapper>
            <NOMBalances />
            <SidebarFooter />
          </DarkWrapper>
        </SidebarLayout>
      </PanelLayout>
    </div>
  );
}
